import { Button } from 'reactstrap';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import AddSecurityCodeForm from '../../../components/AddSecurityCodeModal';

export default function NotAssessable() {
  const [isModalOpen, setIsModalOpen] = useState(true);
  const dispatch = useDispatch();

  return (
    <div className="text-center">
      <div className="my-5">
        <div className="lead">Unable To access this page</div>
        <p>You cannot access this page untill you enter the right password</p>
      </div>
      <Button color="primary" onClick={() => setIsModalOpen(true)}>
        Enter Password
      </Button>

      <AddSecurityCodeForm
        isOpen={isModalOpen}
        onConfirm={() => {
          dispatch({ type: 'TOGGLE_PORT_ACCESS', payload: true });
          setIsModalOpen(false);
        }}
        onCancel={() => setIsModalOpen(false)}
        portingCode
        featureName='portingCode'
      />
    </div>
  );
}
